import fetchGraphQl from "./fetchGraphQl";
import { useQuery } from "react-query";

const fetchGasData =
  (userId: string, { startDate, endDate }: any) =>
  async () => {
    const { data = { gas: [] }, error } = await fetchGraphQl(
      `
      query queryGasData {
        gas: daily_gas_view(where: {timestamp: {_gt: "${startDate.toISOString()}", _lt: "${endDate.toISOString()}"}}, order_by: {timestamp: asc}) {
          timestamp
          delivery
          chp
          boiler
          euros_delivery
          euros_chp
          euros_boiler
          price
        }
      }
    `,
      "queryGasData",
      userId
    ) ?? {};

    let total = {
      gasConsumed: 0,
      chp: 0,
      boiler: 0,
      eurosGasConsumed: 0,
      eurosCHP: 0,
      eurosBoiler: 0,
      price: 0,
      timestamp: '',
    };

    if (!error) {
      data.gas.forEach((dataItem: any, index: number) => {
        total.gasConsumed += dataItem.delivery;
        total.chp += dataItem.chp;
        total.boiler += dataItem.boiler;
        total.eurosGasConsumed += dataItem.euros_delivery;
        total.eurosCHP += dataItem.euros_chp;
        total.eurosBoiler += dataItem.euros_boiler;
        total.price = dataItem.price;
        total.timestamp = dataItem.timestamp;
      });
    }

    return { data: data.gas, total };
  };

export const useGasData = (userId: string, dayRange: any, farmName: string) => {
  return useQuery(["gas", dayRange, farmName], fetchGasData(userId, dayRange), {
    refetchOnWindowFocus: true,
  });
};
